import React, { useEffect } from 'react';

import { useBasicFullscreen } from './basic-fullscreen-context';
import { SharedFullscreenViewer } from './shared-fullscreen-components';

export const BasicFullscreenViewer: React.FC = () => {
  const {
    isFullscreen,
    isBrowserFullscreen,
    exitFullscreen,
    currentDesktop,
    currentCourse,
    currentUser,
    isFreshStartDesktop,
    isParticipantDesktop,
    isTrainerDesktop
  } = useBasicFullscreen();

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement && isFullscreen) {
        exitFullscreen();
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, [isFullscreen, exitFullscreen]);

  if (!currentDesktop || !currentCourse || !currentUser) {
    return null;
  }

  return (
    <SharedFullscreenViewer
      isFullscreen={isFullscreen}
      isBrowserFullscreen={isBrowserFullscreen}
      currentDesktop={currentDesktop}
      currentCourse={currentCourse}
      currentUser={currentUser}
      isFreshStartDesktop={isFreshStartDesktop}
      isParticipantDesktop={isParticipantDesktop}
      isTrainerDesktop={isTrainerDesktop}
      exitFullscreen={exitFullscreen}
      shouldRenderContent={true}
      isSwitching={false}
      showSwitcher={false}
    />
  );
};
